import React, { useEffect, useState } from "react";
import { CardImage, MainCollectionCard } from "./styles";
import {
  AiFillHeart,
  AiOutlineCopy,
  AiOutlineHeart,
  BsFacebook,
  BsThreeDotsVertical,
  BsTwitter,
  FaEthereum,
} from "react-icons/all";
import cardImg from "assets/colection.png";
import imgplaceholder from "../../assets/imgplaceholder.png";
import {
  Buttons,
  DropdownItem,
  DropdownItemA,
  DropdownMenu,
  Dropdowns,
  ToastMessage,
} from "components/common";
import { paymentList } from "components/data/selectData";
import { CommonUtility } from "utility";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";
import { AddViewHook } from "hooks";
const CollectionCard = ({ data }) => {
  const navigate = useNavigate();

  const [tokenIcon, setTokenIcon] = useState("");
  const [amount, setAmount] = useState<any>(0);

  const { web3, account, chainId } = useAppSelector(
    (state) => state.web3Connect
  );

  const handleAmount = async () => {
    let value = data?.metadata?.price;
    const paymentTokens = paymentList(`${data?.metadata?.network}`);
    const erc20Token = paymentTokens.find(
      (x) => x.value.toLocaleLowerCase() === data?.metadata?.erc20Token
    );
    setTokenIcon(erc20Token.icon?.default);
    setAmount(CommonUtility.handleDivDecimals(value, erc20Token.decimals, 4));
  };

  useEffect(() => {
    data && data?.metadata?.price && handleAmount();
  }, [data]);

  const clipToCopy = () => {
    ToastMessage("Copied", "Success", "success");
    navigator.clipboard.writeText(window?.location?.href);
  };

  const menu = (
    <DropdownMenu>
      <DropdownItem>
        <BsTwitter
          style={{
            fontSize: "1.2rem",

            marginLeft: "0.5rem",
          }}
        />
        <DropdownItemA
          // rel="noopener noreferrer"
          href="https://twitter.com/intent/tweet"
          target="_blank"
        >
          Share
        </DropdownItemA>
      </DropdownItem>
      {/* <hr /> */}
      <DropdownItem onClick={clipToCopy}>
        <AiOutlineCopy
          style={{
            fontSize: "1.2rem",

            marginLeft: "0.5rem",
          }}
        />

        <DropdownItemA> copy </DropdownItemA>
      </DropdownItem>
    </DropdownMenu>
  );

  return (
    <div>
      <MainCollectionCard>
        <div className="header ">
          <p>
            {data?.metadata?.name ||
              data?.metadata?.asset_contract?.name ||
              "unkown"}{" "}
            # {data?.metadata?.token_id}
          </p>
          <div>
            {data?.user ? (
              ""
            ) : data?.favId ? (
              <AiFillHeart
                onClick={() =>
                  web3
                    ? data?.changeFav({
                        nft_id: data?.nft_id,
                        userAddress: account,
                        id: data?.favId,
                      })
                    : null
                }
                style={{
                  marginRight: "5px",
                  marginBottom: "3px",
                  cursor: web3 ? "pointer" : "not-allowed",
                }}
                size={20}
              />
            ) : (
              <AiOutlineHeart
                onClick={() =>
                  web3
                    ? data?.changeFav({
                        nft_id: data?.nft_id,
                        userAddress: account,
                      })
                    : null
                }
                style={{
                  marginRight: "5px",
                  marginBottom: "3px",
                  cursor: web3 ? "pointer" : "not-allowed",
                }}
                size={20}
              />
            )}
            <Dropdowns overlay={menu} trigger={["click"]}>
              <BsThreeDotsVertical
                style={{
                  fontWeight: "bold",
                  marginTop: "-0.1rem",
                  cursor: "pointer",
                }}
              />
            </Dropdowns>
          </div>
        </div>
        <div className="cardImgDiv">
          <CardImage
            src={data?.image || imgplaceholder}
            width={215}
            height={235}
          />
        </div>
        <div className="cardInfo">
          <div>
            <p>
              {" "}
              <img
                style={{
                  marginRight: "5px",
                  marginBottom: "3px",
                  fontSize: "25px",
                  color: "#333333",
                  width: "20px",
                }}
                src={tokenIcon}
              />{" "}
              {amount}
            </p>
          </div>

          <button
            disabled={data?.metadata?.sold}
            onClick={() =>
              data?.user
                ? navigate(`/user-nft/${data?.metadata?.id}?chain=${chainId}`)
                : !data?.metadata?.sold
                ? navigate(`/nft-details?slug=${data?.metadata?.id}`)
                : null
            }
            className="buyBtn"
          >
            {data?.buttonTxt}
          </button>
        </div>
      </MainCollectionCard>
    </div>
  );
};

export default CollectionCard;
